/**
 * Creates x locations for objects of the same width
 * @param {any} Scene the array to shuffle
 * @param {integer} NumOfButtons the number of objects to space
 * @param {integer} WidthOfObject the width of the object to be spaced
 * @param {integer} MarginBetweenObjects the gap between each object
 * @param {integer} AdditonalPlusMinus offsets all placed objects. Negative moves to the left, posistive moves right
 */

import ABCyaPhaser from "@abcya/abcya_phaser";

export function TraySpacer(Tray,NumOfButtons,WidthOfObject,MarginBetweenObjects,AdditonalPlusMinus = 0)
{
    //This Function is used to auto determine the x cordinate based on the center of the tray
    //Ideally used for make a games that use the same sized object in a row
    //Will also work if fed even numbers of buttons
    const TrayLeftX = Tray.getTopLeft().x + AdditonalPlusMinus;
    const TrayCenterPoint = (Tray.width/2) + TrayLeftX;
    const PlacementArray = [];

    if (NumOfButtons % 2 === 1)
    {
        let Median = ((NumOfButtons*.5) + .5);
        
        for (let x = 0; x < NumOfButtons; x++)
        {
            if (x+1 > Median)
            {
                let FromMedian = Median - (x+1);
                let MarginGap = FromMedian * MarginBetweenObjects;
                let WidthGap = FromMedian * WidthOfObject;

                PlacementArray[x] = TrayCenterPoint - MarginGap - WidthGap;
            }
            else if(x+1 === Median)
            {
                PlacementArray[x] = TrayCenterPoint;
            }
            else
            {
                let FromMedian = (x+1) - Median;
                let MarginGap = FromMedian * MarginBetweenObjects;
                let WidthGap = FromMedian * WidthOfObject;

                PlacementArray[x] = TrayCenterPoint + MarginGap + WidthGap;
            }
        }
    }
    else
    {
        let MiddleGap = (WidthOfObject + MarginBetweenObjects)*.5;
        let Median = NumOfButtons*.5;

        for (let x = 0; x < NumOfButtons; x++)
        {
            if (x < Median)
            {
                let FromMedian = Median - (x+1);

                let MarginGap = FromMedian * MarginBetweenObjects;
                let WidthGap = FromMedian * WidthOfObject;

                if (FromMedian === 0)
                {
                    PlacementArray[x] = TrayCenterPoint - MiddleGap;
                }
                else
                {
                    PlacementArray[x] = TrayCenterPoint - MarginGap - WidthGap - MiddleGap;
                }
            }
            else
            {
                let FromMedian = (x) - Median;

                let MarginGap = FromMedian * MarginBetweenObjects;
                let WidthGap = FromMedian * WidthOfObject;

                if (FromMedian === 0)
                {
                    PlacementArray[x] = TrayCenterPoint + MiddleGap;
                }
                else
                {
                    PlacementArray[x] = TrayCenterPoint + MarginGap + WidthGap + MiddleGap;
                }
            }
        }
    }

    return PlacementArray;
}

export function AddColorHeader(Scene,Tray)
{
    const ColorButtonArray = [];
    const PlacementArray = TraySpacer(Tray,5,30,5);
    
    const ColorApendArray = ["Wht","Blk","Aqua","Blue","Ylw","Orng","Slvr","LtGrn","DkGrn","Rd","Pnk","Prpl"];

    var text = Scene.add.text(PlacementArray[1],20,ABCyaPhaser.Localization.instance.getLocalizedString("colors_label"),{fontFamily: 'fulbotano', fontSize: 26});
    ABCyaPhaser.Text.resizeFontToFitWidth(text, 100, null, 26);
    text.setTint(0x045613);
    text.setOrigin(.5,.5);
    text.setDepth(Scene.DepthList.OrnBack);
    Scene.TrayGroup.add(text);

    for(let i = 1; i < 6;i++)
    {
        if(i < 3)
        {
            ColorButtonArray.push(Scene.addImage(PlacementArray[i+2],20,"ClrSlct_"+ColorApendArray[i-1]));
        }
        ColorButtonArray.push(Scene.addImage(PlacementArray[(i-1)],55,"ClrSlct_"+ColorApendArray[i+1]));
        ColorButtonArray.push(Scene.addImage(PlacementArray[(i-1)],90,"ClrSlct_"+ColorApendArray[i+6]));
    }

    //console.log(ColorButtonArray);

    Scene.TrayGroup.addMultiple(ColorButtonArray);

    for (let x in ColorButtonArray)
    {
        ColorButtonArray[x].setInteractive();
        ColorButtonArray[x].on('pointerdown', ColorClickHandler, this)
        ColorButtonArray[x].setDepth(Scene.DepthList.OrnBack);
        // {
        //     //console.log("In button : "+this);
        //     ColorClickHandler(Scene,this);
        // });
    }

    Scene.TrayGroup.add(Scene.addImage(PlacementArray[2],120,"Line").setDepth(Scene.DepthList.OrnBack));
}

export function ColorClickHandler()
{
    let Scene = this.scene;
    let ColorName = this.frame.name.slice(8);

    //console.log(ColorName);

    if (ColorName.includes("_")) ColorName = ColorName.slice(5);

    if(Scene.CurrentTabName === "Gfts" && ColorName === "Wht")
    {
        Scene.GiftGroup.getChildren().forEach(element =>
            {
                element.setAlpha(1);
            });
    }
    else if(Scene.CurrentTabName === "Gfts" && ColorName != "Wht")
    {
        Scene.GiftGroup.getChildren().forEach(element =>
            {
                element.setAlpha(0);
            });
    }

    //console.log(ColorName);

    Scene.AudioChan.Chan5.play('click_in_game');

    switch(ColorName)
    {
        case "Wht":
            SetGroupTint(Scene,"ColorGroup",0xFFFFFF);
            break;
        case "Blk":
            SetGroupTint(Scene,"ColorGroup",0x353A3D);
            break;
        case "Aqua":
            SetGroupTint(Scene,"ColorGroup",0xAFCFF);
            break;
        case "Blue":
            SetGroupTint(Scene,"ColorGroup",0x266CF9);
            break;
        case "Ylw":
            SetGroupTint(Scene,"ColorGroup",0xFFDD00);
            break;
        case "Orng":
            SetGroupTint(Scene,"ColorGroup",0xFF7900);
            break;
        case "Slvr":
            SetGroupTint(Scene,"ColorGroup",0xC1C1C1);
            break;
        case "LtGrn":
            SetGroupTint(Scene,"ColorGroup",0x83FF00);
            break;
        case "DkGrn":
            SetGroupTint(Scene,"ColorGroup",0x088B04);
            break;
        case "Rd":
            SetGroupTint(Scene,"ColorGroup",0xF70D0D);
            break;
        case "Pnk":
            SetGroupTint(Scene,"ColorGroup",0xF761AF);
            break;
        case "Prpl":
            SetGroupTint(Scene,"ColorGroup",0xBE6FF4);
            break;
        case "1"://Dark Green
            SetGroupTint(Scene,"ColorGroup",0x045613);
            SetGroupTint(Scene,"OutlineGroup",0x03300B);
            break;    
        case "2"://Red
            SetGroupTint(Scene,"ColorGroup",0xFC3232);
            SetGroupTint(Scene,"OutlineGroup",0xAF0505);
            break;
        case "3"://Pink
            SetGroupTint(Scene,"ColorGroup",0xF9B9CC);
            SetGroupTint(Scene,"OutlineGroup",0xF471A4);
            break;
        case "4"://White
            SetGroupTint(Scene,"ColorGroup",0xFAFCFF);
            SetGroupTint(Scene,"OutlineGroup",0xB0A3C6);
            break;
        case "5"://Black
            SetGroupTint(Scene,"ColorGroup",0x23282B);
            SetGroupTint(Scene,"OutlineGroup",0x000000);
            break;
        default:
            //console.log(ColorName +" Not a Color");
            break;
    }

    function SetGroupTint(Scene,Group,Tint)
    {
        Scene[Group].getChildren().forEach(element =>
            {
                element.setTint(Tint);
            });

        if(Scene.DrawArray[0]) Scene.DrawArray[0].tint = Tint;
    }
}